import debug from 'debug';

export const logger = debug('signalview').extend;
export default logger;
